enum CustomerPostalAddressGroup {
  RESIDENCE = 'RESIDENCE',
  CONTACT = 'CONTACT',
}

export default CustomerPostalAddressGroup;
